import styled, { css } from 'styled-components';

/** Shared surface wrapper for Gator Protect chart and threats panels. */
export const GatorProtectPanel = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    border-radius: 16px;
    padding: 32px;
    background-color: ${theme.v3.colors.neutral[100]};


    @media (min-width: ${theme.v3.breakpoints.md}) {
      padding: 24px;
    }
  `}
`;

/** Shared panel heading (chart title; base for threats table title variants). */
export const GatorProtectPanelTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 0 32px 0;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin: 0 0 24px 0;
    }
  `}
`;

/** Shared calendar + label chip (chart filter; base for threats date strip). */
export const GatorProtectDateRangeBadge = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 16px;
    color: ${theme.v3.colors.neutral[10]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `};
`;

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 40px 32px 40px;
    font-family: 'Galano', 'Roboto', sans-serif, 'Helvetica Neue', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 0 16px 0;
    }
  `}
`;

export const DataAndMetricsRow = styled.div`
  ${({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  
  @media (min-width: ${theme.v3.breakpoints.lg}) {
    flex-direction: row;
    gap: 40px;
    justify-content: space-between;
  `}
`;
